//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  components: {  },
  data () {
    return {}
  },
  props: ['obj'],
  computed: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onClickRight() {
      //Toast('按钮');
    }
  }
}
